const locale = {
  APPLICATIONS: 'Main Menu',
  DASHBOARD: 'Panel',
  USERS: 'User Management',
  MANAGEMENT: 'Management',
  EXAMPLE: 'Example Page'
};

export default locale;
